<div class="ui middle aligned center aligned grid">
    <div class="column">
        <h2 class="ui teal image header">
            <img src="../../../../../assets/img/logoAndName.png" class="image">
            <div class="content">
                Se connecter au panneau d'admnistration
            </div>
        </h2>
        <form class="ui large form" (submit)="login()">
            <div class="ui stacked segment">
                <div class="field">
                    <div class="ui left icon input">
                        <i class="lock icon"></i>
                        <input type="password" name="password" placeholder="Mot de passe" [(ngModel)]="password">
                    </div>
                </div>
                <div class="ui fluid large teal submit button" (click)="login()">Login</div>
            </div>
        </form>
    </div>
</div>
<error-popup></error-popup>


// WEBPACK FOOTER //
// C:/Users/Benoit/WebstormProjects/schiltz/client/src/app/presentation/components/admin/mainPage/mainPage.html